import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=48b79450&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=48b79450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b79450",
  null
  
)

export default component.exports